export const SALE_CARD_QUERY_BLOB: string = `{
  id
  type
  dates {
    end
    start
  }
  photos(limit: 1) {
    url
    urlWithSize
    caption
  }
  tags
  prices {
    currency {
      currencyCode
    }
    depositFromPrice {
      forDisplay
    }
    discount
    discountTooltip
    leadRate {
      forDisplay
    }
    leadRateLabel
    leadRateTooltip
    leadRateUnitLabel
    pricingRules {
      showDiscount
      showPrices
      showRackRate
    }
    rackRate {
      forDisplay
    }
  }

  editorial {
    title
    destinationName
    reasonToLove
  }

  attributes {
    isSmartStay
    isEditorsPick
    isExclusive
    isDepositSale
    isZeroDeposit
    isTimeLimited
  }

  links {
    sale
  }

  promotion {
    hexCode
    label
    description
    iconCode
  }

  labels {
    hexCode
    iconCode
    labelKey
    summary
  }

  travel {
    hasFlightsIncluded
    hasFlightsAvailable
  }

  bookingStats {
    currentVisitors
    timesBooked
  }
  location {
    latitude
    longitude
  }
}`;

export const SALE_CARD_MAP_BLOB: string = `{
  id
  location {
    latitude
    longitude
  }
}`;
